fragment StaffTrainingCourseSummaryFields on StaffTrainingCourseSummary {
  id
  slug
  title
  summary
  posterUrl
  category {
    id
    name
  }
  mandatory
  started
  status
  dueOn
  daysLeft
  moduleCount
  completeCount
  nextModuleSlug
  moduleSlug
}
